import React, { useEffect, useState } from 'react';
import LazyLoad from 'react-lazyload';
import { Link } from 'react-router-dom';
import { getPrincipalMessage } from '../Service/Api';
const removeHtmlTags = (str) => {
  return str.replace(/<[^>]*>/g, ''); // Removes anything between '<' and '>'
};
const Message = () => {
  const [data, setData] = useState([]);
  const [data1, setData1] = useState([]);
  useEffect(() => {
    const msgData = async () => {
      const msgDataGet = await getPrincipalMessage();
      const principalMsg = msgDataGet.filter((item) => item.category === "Director");
      setData(principalMsg);
      const directorMsg = msgDataGet.filter((item) => item.category === "Principal");
      setData1(directorMsg);
    }
    msgData();
  }, [])

  return (
    <>
      <div className='message_blk'>
        <div className='d-flex'>
          {data.length > 0 ? data.map((item) => (
            <>
              <div className='message_img chairman orderd-1'>
                <LazyLoad><img src={`https://webapi.entab.info/api/image/${item.attachments[0]}`} className='img-fluid msg-img' alt="St francis school, Amritsar"></img></LazyLoad>
                <LazyLoad><img src='https://webapi.entab.info/api/image/SFSAP/public/Images/message-btn.gif' className='message-btn' alt="St francis school, Amritsar" /></LazyLoad>
              </div>
              <div className='message_content orderd-2'>
                <h5>{item.name}</h5>
                <h6>{item.designation}</h6>
                <p>{removeHtmlTags(item.message)}</p>
                <button className='button'><Link to="/director"> VIEW ALL </Link></button>
              </div>
            </>
          )) : (
            <>
              <div className='message_img chairman orderd-1'>
                <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/director.png" className='img-fluid msg-img' alt="St francis school, Amritsar"></img></LazyLoad>
                <LazyLoad><img src='https://webapi.entab.info/api/image/SFSAP/public/Images/message-btn.gif' className='message-btn' alt="St francis school, Amritsar" /></LazyLoad>
              </div>
              <div className='message_content orderd-2'>
                <h5>REV. FR. MATHEW JOSEPH MANALUMPARAYIL</h5>
                <h6>DIRECTOR</h6>
                <p>In the pilgrimage of constant and continuous learning. Let us all move together towards Ever-widening horizon. Wishing all of you still greater heights in the new academic session.</p>
                <button className='button'><Link to="/"> VIEW ALL </Link></button>
              </div>
            </>
          )}
          {data1.length > 0 ? data1.map((item) => (
            <>
              <div className='message_img chairman orderd-1'>
                <LazyLoad><img src={`https://webapi.entab.info/api/image/${item.attachments[0]}`} className='img-fluid msg-img' alt="St francis school, Amritsar"></img></LazyLoad>
                <LazyLoad><img src='https://webapi.entab.info/api/image/SFSAP/public/Images/message-btn.gif' className='message-btn' alt="St francis school, Amritsar" /></LazyLoad>
              </div>
              <div className='message_content orderd-2'>
                <h5>{item.name}</h5>
                <h6>{item.designation}</h6>
                <p>{removeHtmlTags(item.message)}</p>
                <button className='button'><Link to="/principal"> VIEW ALL </Link></button>
              </div>
            </>
          )) : (
            <>
              <div className='message_img chairman orderd-1'>
                <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/principal.png" className='img-fluid msg-img' alt="St francis school, Amritsar"></img></LazyLoad>
                <LazyLoad><img src='https://webapi.entab.info/api/image/SFSAP/public/Images/message-btn.gif' className='message-btn' alt="St francis school, Amritsar" /></LazyLoad>
              </div>
              <div className='message_content orderd-2'>
                <h5>SR. SOOSAI MARY</h5>
                <h6>PRINCIPAL</h6>
                <p>One child, One teacher, One book. One pen can change the world. Let us the little children come to me, do not stop them, for it is to such as these that the kingdom of God belongs.</p>
                <button className='button'><Link to="/principal">VIEW ALL</Link></button>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default Message;
